/* This rule is meant to skip the user-attributes-collection if it only receives one item.
 *  It will improve the overall performance of the component since it skips the request to SiFU in order to fetch the userInfo.
 *  The child component will be renderer on SSR.
 */
import { hasTag } from '@ycos/coremedia-renderer'

const checkIfContentIsTargeted = (items) => {
  return items.some((item) => {
    return hasTag(item.tags, 'CustomerSegments') 
  })
}

const UserAttributesCollectionRule = ({ item }) => {
  const { layoutVariant, items } = item
  if (layoutVariant === 'isc-user-attributes-collection') {
    return {
      item,
      skipComponent: items.length === 1 || !checkIfContentIsTargeted(items)
    }
  }

  return { item }
}

export default UserAttributesCollectionRule
